// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__2HPZf","colorContainer":"styles_colorContainer__3-ts1"};